import { Flex } from '@chakra-ui/react';
import GlobalFilter from './modules/globalFilter';
import Filter from './modules/filter';
import CardContainer from './components/cardContainer';
import Table from './modules/table';
import ResyncModal from './components/resyncModal';
import { useGlobalFilter } from './hooks/state/globalFilter';
import { useFilter } from './hooks/state/filters';
import { useEffect } from 'react';

export default function SelloutMonitoring() {
    const { reset } = useGlobalFilter();
    const { resetFilter } = useFilter();

    useEffect(() => {
        return () => {
            reset();
            resetFilter();
        };
    }, []);

    return (
        <Flex minW={'xl'} gap={'24px'} flexDirection={'column'}>
            <GlobalFilter />

            <CardContainer>
                <Filter />
                <Table />
            </CardContainer>

            <ResyncModal />
        </Flex>
    );
}
